/*
 * Popup 2 de salida — regalo PetBeat (bálsamo para nariz y patitas)
 *
 * - Móvil (≤768px): aparece en el intento de salir ("atrás") que sigue después de que ya se mostró el popup 1
 *   (exit-intent-tapete-mobile.js), sin importar si el popup 1 salió por "atrás" o por inactividad.
 * - Escritorio: segundo intento de salir por arriba de la ventana.
 * - Se muestra EN CADA VISITA (una vez por página vista), mientras la persona no haya comprado
 *   (window.pbPurchased) y no tenga ya el regalo en el carrito. Productos y colecciones; no home ni carrito.
 *
 * El regalo es un producto oculto (UNLISTED) con el código REGALOBALSAMO (100 %, una vez por cliente).
 * Se agrega al carrito solo cuando ya hay otra compra en él.
 */

(function () {
  'use strict';

  const CONFIG = {
    id: 'pb-gift-popup',
    variantId: 41395851690056,
    giftHandle: 'regalo-balsamo-nariz-patitas-petbeat',
    code: 'REGALOBALSAMO',
    image: 'https://cdn.shopify.com/s/files/1/0591/4502/7656/files/fadaefc7-9fbd-487d-998b-808817c20dbe.jpg?v=1791245453&width=420',
    mobileBreakpoint: 768,
    claimedKey: 'pb_gift_claimed',
  };

  const mem = {};
  const store = {
    get(key) {
      try {
        const v = window.localStorage.getItem(key);
        return v === null ? (mem[key] === undefined ? null : mem[key]) : v;
      } catch (e) {
        return mem[key] === undefined ? null : mem[key];
      }
    },
    set(key, value) {
      mem[key] = value;
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        /* almacenamiento bloqueado: queda en memoria */
      }
    },
  };

  const json = (url, options) =>
    fetch(url, Object.assign({ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }, options)).then((r) => {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });

  const Cart = {
    get: () => json('/cart.js'),
    hasGift: (cart) => (cart.items || []).some((i) => i.variant_id === CONFIG.variantId),
    hasOther: (cart) => (cart.items || []).some((i) => i.variant_id !== CONFIG.variantId),
    async addGift() {
      await json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: CONFIG.variantId, quantity: 1 }] }) });
      await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ discount: CONFIG.code }) });
    },
  };

  const Gift = {
    popup: null,
    shown: false,
    lastFocus: null,

    init() {
      const log = window.pbLog || function () {};
      if (window.pbPurchased) {
        log('regalo omitido: ya compró');
        return;
      }
      const path = window.location.pathname.replace(/\/+$/, '') || '/';
      if (path === '/' || /^(\/[a-z]{2}(-[A-Za-z]{2})?)?$/.test(path) || path.indexOf('/cart') === 0 || path.indexOf(CONFIG.giftHandle) !== -1) {
        log('regalo omitido: página ' + path);
        return;
      }

      // Si ya lo reservó antes, se agrega solo en cuanto haya una compra en el carrito.
      if (store.get(CONFIG.claimedKey) === '1') {
        this.completeIfReady();
        document.addEventListener('shopify:cart:lines-update', () => this.completeIfReady());
      }

      // Se arma de inmediato (no espera al carrito) para no perder el primer "atrás".
      if (window.innerWidth <= CONFIG.mobileBreakpoint) this.armMobile();
      else this.armDesktop();
      log('regalo init ok');
    },

    // Antes de mostrarlo se confirma que el regalo no esté ya en el carrito.
    tryShow() {
      if (this.shown) return;
      this.shown = true;
      Cart.get()
        .then((cart) => {
          if (Cart.hasGift(cart)) {
            (window.pbLog || function () {})('regalo omitido: ya está en el carrito');
            return;
          }
          this.show();
        })
        .catch(() => this.show());
    },

    armMobile() {
      const log = window.pbLog || function () {};
      let hasEntry = false;

      const ensureEntry = () => {
        if (hasEntry || this.shown) return;
        window.history.pushState({ pbGift: true }, '', window.location.href);
        hasEntry = true;
      };
      ['touchend', 'click'].forEach((evt) =>
        document.addEventListener(evt, ensureEntry, { passive: true, capture: true })
      );

      window.addEventListener('popstate', (e) => {
        hasEntry = false;
        if (this.shown) return;
        // Le toca solo si el popup 1 ya estaba visible ANTES de este "atrás".
        const p1Before = !!window.pbExitShown && window.pbExitShowEvent !== e;
        log('regalo popstate p1Antes=' + p1Before);
        if (!p1Before) return;
        this.tryShow();
        try {
          window.history.pushState({ pbGift: true }, '', window.location.href);
          hasEntry = true;
        } catch (err) {
          /* se repone en el siguiente toque */
        }
      });
    },

    armDesktop() {
      let attempts = 0;
      document.addEventListener('mouseout', (e) => {
        if (this.shown || e.relatedTarget || e.clientY > 0) return;
        attempts += 1;
        if (attempts >= 2) this.tryShow();
      });
    },

    render() {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = `
        <div class="pb-gift" id="${CONFIG.id}" role="dialog" aria-modal="true" aria-labelledby="pb-gift-title" hidden>
          <div class="pb-gift__card">
            <button type="button" class="pb-gift__close" aria-label="Cerrar" data-pb-gift-close>
              <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
            </button>
            <div data-pb-gift-main>
              <h2 class="pb-gift__title" id="pb-gift-title">🐾¡NO TE VAYAS SIN SU REGALO!🐶</h2>
              <p class="pb-gift__lead">Hoy tu primera compra incluye un regalo GRATIS 🎁</p>
              <div class="pb-gift__product">
                <img data-pb-gift-img width="140" height="140" alt="Bálsamo para nariz y patitas PetBeat" decoding="async">
                <div class="pb-gift__price">
                  <span class="pb-gift__badge">Regalo</span>
                  <s>$283</s>
                  <strong>GRATIS</strong>
                </div>
              </div>
              <p class="pb-gift__love">Tu perrito merece ese extra 💛</p>
              <p class="pb-gift__text">Recibe GRATIS un bálsamo con Vitamina E para el cuidado de su nariz y patitas al realizar tu primera compra.</p>
              <p class="pb-gift__tag">Tu compra es para ti.<br><strong>El regalo es para él. 🐾</strong></p>
              <button type="button" class="pb-gift__cta" data-pb-gift-cta>Quiero su regalo 🎁</button>
              <button type="button" class="pb-gift__skip" data-pb-gift-close>No, gracias</button>
            </div>
            <div data-pb-gift-done hidden>
              <h2 class="pb-gift__title">🎁 ¡Regalo reservado!</h2>
              <p class="pb-gift__text" data-pb-gift-done-text></p>
              <button type="button" class="pb-gift__cta" data-pb-gift-next>Continuar</button>
            </div>
          </div>
        </div>`;
      this.popup = wrapper.firstElementChild;
      document.body.appendChild(this.popup);
      this.injectStyles();

      this.popup.querySelectorAll('[data-pb-gift-close]').forEach((b) => b.addEventListener('click', () => this.hide()));
      this.popup.addEventListener('click', (e) => {
        if (e.target === this.popup) this.hide();
      });
      this.popup.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.hide();
      });
      this.popup.querySelector('[data-pb-gift-cta]').addEventListener('click', (e) => this.claim(e.currentTarget));
    },

    show() {
      if (this.popup) return;
      (window.pbLog || function () {})('regalo SHOW');
      // Si el popup 1 sigue abierto, se cierra para que no queden dos encimados.
      const p1 = document.getElementById('pb-exit-popup');
      if (p1) p1.hidden = true;
      this.render();
      this.popup.querySelector('[data-pb-gift-img]').src = CONFIG.image;
      this.lastFocus = document.activeElement;
      this.popup.hidden = false;
      this.popup.querySelector('.pb-gift__close').focus({ preventScroll: true });
    },

    hide() {
      if (!this.popup) return;
      this.popup.hidden = true;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },

    async completeIfReady() {
      try {
        const cart = await Cart.get();
        if (Cart.hasGift(cart) || !Cart.hasOther(cart)) return;
        await Cart.addGift();
      } catch (e) {
        console.warn('[PetBeat regalo]', e);
      }
    },

    async claim(button) {
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = 'Reservando…';
      try {
        const cart = await Cart.get();
        const main = this.popup.querySelector('[data-pb-gift-main]');
        const done = this.popup.querySelector('[data-pb-gift-done]');
        const text = done.querySelector('[data-pb-gift-done-text]');
        const next = done.querySelector('[data-pb-gift-next]');

        if (Cart.hasOther(cart)) {
          await Cart.addGift();
          window.location.href = '/cart';
          return;
        }

        store.set(CONFIG.claimedKey, '1');
        document.addEventListener('shopify:cart:lines-update', () => this.completeIfReady());
        text.textContent = 'Elige su juguete favorito: al agregarlo a tu carrito, el bálsamo se suma GRATIS.';
        next.addEventListener('click', () => this.hide());
        main.hidden = true;
        done.hidden = false;
      } catch (error) {
        console.warn('[PetBeat regalo]', error);
        button.disabled = false;
        button.textContent = 'Quiero su regalo 🎁';
        this.hide();
      }
    },

    injectStyles() {
      if (document.getElementById('pb-gift-styles')) return;
      const css = `
        .pb-gift {
          --pbg-green: #2e3a24;
          --pbg-gold: #c6a038;
          --pbg-ivory: #f6f1eb;
          --pbg-ebony: #0f0f10;
          position: fixed;
          inset: 0;
          z-index: 2147483001;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: max(16px, env(safe-area-inset-top)) 16px max(16px, env(safe-area-inset-bottom));
          background: rgb(15 15 16 / 0.66);
          font-family: var(--font-body--family, 'Inter', system-ui, -apple-system, sans-serif);
          animation: pbg-fade 0.25s ease-out;
        }
        .pb-gift[hidden], .pb-gift [hidden] { display: none; }
        .pb-gift__card {
          position: relative;
          width: 100%;
          max-width: 380px;
          max-height: calc(100dvh - 32px);
          overflow-y: auto;
          box-sizing: border-box;
          padding: 34px 22px 18px;
          border: 1px solid rgb(198 160 56 / 0.5);
          border-radius: 20px;
          background: var(--pbg-green);
          color: var(--pbg-ivory);
          text-align: center;
          box-shadow: 0 24px 60px rgb(15 15 16 / 0.45);
          animation: pbg-rise 0.3s ease-out;
        }
        .pb-gift__close {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 44px;
          height: 44px;
          display: grid;
          place-items: center;
          padding: 0;
          border: 1px solid rgb(246 241 235 / 0.35);
          border-radius: 50%;
          background: rgb(246 241 235 / 0.08);
          color: var(--pbg-ivory);
          cursor: pointer;
        }
        .pb-gift__title {
          margin: 0 auto 8px;
          max-width: 11em;
          font-family: var(--pb-serif-font, 'Cormorant', Georgia, 'Times New Roman', serif);
          font-weight: 600;
          font-size: 1.75rem;
          line-height: 1.08;
          color: var(--pbg-ivory);
          text-wrap: balance;
        }
        .pb-gift__lead {
          margin: 0 0 12px;
          font-size: 1rem;
          font-weight: 700;
          color: var(--pbg-gold);
        }
        .pb-gift__product {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 14px;
          margin: 0 0 12px;
          padding: 10px;
          border-radius: 16px;
          background: #fff;
        }
        .pb-gift__product img {
          width: 120px;
          height: 120px;
          object-fit: contain;
        }
        .pb-gift__price {
          display: grid;
          justify-items: start;
          gap: 2px;
          color: var(--pbg-ebony);
        }
        .pb-gift__price s { font-size: 1rem; color: #777; }
        .pb-gift__price strong {
          font-family: var(--pb-serif-font, 'Cormorant', Georgia, serif);
          font-size: 2.1rem;
          line-height: 1;
          color: var(--pbg-green);
        }
        .pb-gift__badge {
          padding: 3px 10px;
          border-radius: 999px;
          background: var(--pbg-gold);
          color: var(--pbg-ebony);
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
        }
        .pb-gift__love {
          margin: 0 0 6px;
          font-size: 1.05rem;
          font-weight: 600;
        }
        .pb-gift__text {
          margin: 0 auto 10px;
          max-width: 21em;
          font-size: 0.9rem;
          line-height: 1.45;
          color: rgb(246 241 235 / 0.82);
        }
        .pb-gift__tag {
          margin: 0 0 16px;
          font-size: 0.85rem;
          line-height: 1.4;
          color: rgb(246 241 235 / 0.82);
        }
        .pb-gift__tag strong { color: var(--pbg-gold); }
        .pb-gift__cta {
          display: block;
          width: 100%;
          min-height: 54px;
          border: 0;
          border-radius: 999px;
          background: var(--pbg-gold);
          color: var(--pbg-ebony);
          font: inherit;
          font-size: 1rem;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          cursor: pointer;
        }
        .pb-gift__cta:disabled { opacity: 0.75; cursor: progress; }
        .pb-gift__skip {
          display: block;
          width: 100%;
          min-height: 44px;
          margin-top: 4px;
          border: 0;
          background: none;
          color: rgb(246 241 235 / 0.7);
          font: inherit;
          font-size: 0.85rem;
          text-decoration: underline;
          text-underline-offset: 3px;
          cursor: pointer;
        }
        .pb-gift button:focus-visible { outline: 2px solid var(--pbg-gold); outline-offset: 2px; }
        @media (max-height: 640px) {
          .pb-gift__card { padding-top: 26px; }
          .pb-gift__title { font-size: 1.45rem; }
          .pb-gift__product img { width: 90px; height: 90px; }
        }
        @keyframes pbg-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pbg-rise { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
        @media (prefers-reduced-motion: reduce) {
          .pb-gift, .pb-gift__card { animation: none; }
        }
      `;
      const style = document.createElement('style');
      style.id = 'pb-gift-styles';
      style.textContent = css;
      document.head.appendChild(style);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Gift.init());
  } else {
    Gift.init();
  }
})();
